Page = {

	current:{},
	useAnimationBlocks: true,
	animationTime:1001,

	load: function(PAGE, URL){

		if(App.debug){
			console.log('--- Page.load -----------------------------');
			console.log('Router', Router);
			console.log('PAGE', PAGE);
			console.log('URL', URL);
		}

		PAGE.addClass('loading');
		this.Loader.show(PAGE);
		PAGE.attr('url', URL);

		$.ajax({
			type: "POST",
			url: WEB_ROOT + "/" + URL,
			beforeSend: function(){},
			success: function(result) {
				if ( !result ) return;
				Page.add(PAGE, result);
				return;
			},
			error: function(result, jqXHR, textStatus, errorThrown) {
				// if ( !result ) return;
				console.log(PAGE, result)
				Page.add(PAGE, result.responseText);
				console.log("ERROR", jqXHR, textStatus, errorThrown);
				return;
			}
		});
	},

	add: function(PAGE, html){
		if(App.debug){
			console.log('--- Page.add -----------------------------');
			console.log('PAGE', PAGE);
		}

		var oldContent = PAGE.find('content');
		oldContent
			.removeClass(oldContent.attr('anim-in'))
			.addClass(oldContent.attr('anim-out'));

		// console.log(oldContent.attr('anim-out'), oldContent.attr('anim-in'), oldContent)

		var newContent = $('<div>').hide().html(html).find('content').first();
		newContent
			.attr({"state":"added", "content":Router.path})
			.removeClass(newContent.attr('anim-out'))
			.addClass(newContent.attr('anim-in'))
			.appendTo(PAGE)

		PAGE
			.removeClass('loading')
			.addClass('showing');

		if(PAGE.attr('state') != "open" && (PAGE.attr('direction') != "next" || PAGE.attr('direction') != "prev") ){
			PAGE.height(oldContent.outerHeight())
			// this.setHeight(PAGE, oldContent.outerHeight(), newContent.outerHeight());

			setTimeout(function(){
				PAGE.velocity({height: newContent.outerHeight()}, {
					duration: 1000, easing: "easeOutSine",
					complete: function(){
						page = $(this);
						setTimeout(function(){page.removeAttr('style')}, 1)
					}
				});
			}, 1)
		}
		
		this.init(PAGE);
		this.show(PAGE);
	},

	init: function(PAGE){

		if(typeof Editor != "undefined") return;
		
		if(App.debug){
			console.log('--- Page.init -----------------------------');
			console.log('arguments', arguments);
		}

		if(PAGE){
			var newContent = PAGE.find('content[state="added"]');
			PAGE = newContent.length ? newContent : PAGE;
		} else {
			PAGE = $('body')
		}

		// PAGE = PAGE ? PAGE.find('content[state="added"]') : $('body');

		//Manually trigger pageView on GA
		if(window.ga && typeof window.ga.getAll === "function"){
			var tracker = window.ga.getAll()[0];
		} else if (window.ga && typeof ga.getAll === "function") {
			var tracker = ga.getAll()[0];
		}

		if (typeof tracker !== "undefined") {
			// console.log("tracker");
			tracker.set('page', location.pathname);
			tracker.send('pageview');
		}

		Router.bindAnchors(PAGE);
		Picture.init(PAGE);
		// Nominations.init(PAGE);
		// Hlasovanie.init(PAGE);
		// Homepage.init(PAGE);
		// Arrows.init(PAGE);
		
		initAjaxForms();
		initRecaptcha();
		Form.init();

		$("main").animate({ scrollTop: 0 }, "slow");
	},

	show: function(PAGE){
		var oldContent = PAGE.find('content[state="current"], content:not([state]), content[state="show"]')
			.attr('state', 'hide');

		var newContent = PAGE.find('content[state="added"]')
			.attr('state', 'show');

		if(this.useAnimationBlocks){
			Block.hide(oldContent.find('[anim-type]'));

			var newBlocks = newContent.find('[anim-type]').addClass('hidden');
			Block.show(newBlocks);
		}

		setTimeout(function(){
			Page.change(PAGE);
		},	Page.animationTime)

		this.Loader.hide(PAGE);

	},

	change: function(PAGE){

		if(this.useAnimationBlocks){
			var newBlocks = PAGE.find('content[state="show"]').find('[anim-type="after"]');
			Block.show(newBlocks);
		}

		PAGE.find('content[state="show"]').attr('state', 'current');
		PAGE.removeClass('showing');

		Page.remove(PAGE);
	},

	remove: function(PAGE){
		PAGE.find('[state="hide"]').remove();
		PAGE.removeAttr('style');
	},

	reset: function(PAGE, URL){

		if(App.debug){
			console.log('--- Page.reset -----------------------------');
			console.log('PAGE', PAGE);
			console.log('URL', URL);
		}

		$.ajax({
			type: "POST",
			url: WEB_ROOT + '/'+ URL,
			beforeSend: function(){},
			success: function(result) {
				if ( !result ) return;
				Page.replaceContent(result, URL, PAGE);
				return;
			},
			error: function(jqXHR, textStatus, errorThrown) {
				console.log("ERROR", jqXHR, textStatus, errorThrown);
			}
		});
	},

	replaceContent: function(html, URL, PAGE){
		
		if(App.debug){
			console.log('--- Page.replaceContent -----------------------------');
			console.log('page', PAGE);
			console.log('pageUrl', URL);
		}

		var content = $('<div>').hide().html(html).find('content').first();
		PAGE.find('content').replaceWith(content);
		PAGE.attr('url', URL);
		Page.init(PAGE);
	},

	Loader: {
		button:{},
		show: function(PAGE){
			// var overlay = $('<div>', {"class": "overlay"}).prependTo(PAGE)
			// setTimeout(function(){overlay.addClass('show')},1);

			var webRoot = "/project-stars.com/";
        	var webRoot = "/";

			var url = webRoot + Router.path;
			this.button = PAGE.find('content[state="current"]').find('a[href="' + url + '"]');
			this.button.attr('load', true);
		},

		hide: function(PAGE){
			// console.log('overlay hide', Page.current.find('.overlay'));
			// PAGE.find('.overlay').removeClass('show');
			// setTimeout(function(){PAGE.find('.overlay').remove(); },500);
			this.button.removeAttr('load');
		}
	}

},

